module.exports = __webpack_public_path__ + "img/BuinzooLogoMobile.9acf7697.png";